import { Grid } from '@mui/material'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import InputCustom from '../../atoms/input/InputCustom'
import CommonModal from '../../atoms/modal/CommonModal'

import styles from './index.module.scss'
import SelectCustom from '../../atoms/select/SelectCustom'
import PlannerInvoiceStepper from './PlannerInvoiceStepper'

const options = [
	{ value: 'completed', label: 'Completed' },
	{ value: 'charged', label: 'Charged' },
	{ value: 'pending', label: 'Pending' },
]

export default function Modal({
	activeModal,
	closeAllModals,
	handleSubmit,
	page,
}) {
	return (
		<>
			<CommonModal
				open={activeModal === 'create'}
				handleClose={closeAllModals}
				heading="Create Invoice"
				footerContent={
					<>
						{page !== 'planner-payments' && (
							<>
								<ButtonCustom
									onClick={closeAllModals}
									variant="outlined"
									size="lg"
								>
									Cancel
								</ButtonCustom>
								<ButtonCustom
									variant="default"
									size="lg"
									onClick={handleSubmit}
								>
									Create
								</ButtonCustom>
							</>
						)}
					</>
				}
				page="planner-payments"
			>
				{page !== 'planner-payments' && (
					<form onSubmit={handleSubmit} className={styles.formWrp}>
						<Grid container spacing={1.5}>
							<Grid size={{ xs: 12, md: 12 }}>
								<input
									type="text"
									name="party"
									id="party"
									placeholder="Party Name"
									className={styles.titleInput}
								/>
							</Grid>
							<Grid size={{ xs: 12, md: 12 }}>
								<InputCustom
									type="number"
									name="amount"
									id="amount"
									placeholder="Amount"
									className=""
								/>
							</Grid>
							<Grid size={{ xs: 12, md: 12 }}>
								<div className={styles.formField}>
									<label
										htmlFor="DueDate"
										className={styles.label}
									>
										Due Date
									</label>
									<InputCustom type="date" name="date" />
								</div>
							</Grid>
							<Grid size={{ xs: 12, sm: 12 }}>
								<div className={styles.formField}>
									<label
										htmlFor="Status"
										className={styles.label}
									>
										Status
									</label>
									<SelectCustom
										label="Select user"
										options={options}
									/>
								</div>
							</Grid>
						</Grid>
					</form>
				)}
				{page === 'planner-payments' && (
					<PlannerInvoiceStepper onSubmit={closeAllModals} />
				)}
			</CommonModal>
		</>
	)
}
